export const DIAL_CODES = [
  ["🇵🇹", "Portugal", "+351"],
  ["🇲🇿", "Moçambique", "+258"],
  ["🇦🇴", "Angola", "+244"],
  ["🇧🇷", "Brasil", "+55"],
  ["🇨🇻", "Cabo Verde", "+238"],
  ["🇬🇼", "Guiné-Bissau", "+245"],
  ["🇸🇹", "São Tomé e Príncipe", "+239"],
  ["🇹🇱", "Timor-Leste", "+670"],
  ["🇫🇷", "França", "+33"],
  ["🇨🇭", "Suíça", "+41"],
  ["🇱🇺", "Luxemburgo", "+352"],
  ["🇩🇪", "Alemanha", "+49"],
  ["🇬🇧", "Reino Unido", "+44"],
  ["🇮🇪", "Irlanda", "+353"],
  ["🇳🇱", "Países Baixos", "+31"],
  ["🇧🇪", "Bélgica", "+32"],
  ["🇪🇸", "Espanha", "+34"],
  ["🇮🇹", "Itália", "+39"],
  ["🇦🇹", "Áustria", "+43"],
  ["🇸🇪", "Suécia", "+46"],
  ["🇳🇴", "Noruega", "+47"],
  ["🇩🇰", "Dinamarca", "+45"],
  ["🇫🇮", "Finlândia", "+358"],
  ["🇵🇱", "Polónia", "+48"],
  ["🇺🇸", "EUA / Canadá", "+1"],
  ["🇦🇺", "Austrália", "+61"],
  ["🇦🇪", "Emirados Árabes", "+971"],
  ["🇿🇦", "África do Sul", "+27"],
  ["🇲🇦", "Marrocos", "+212"],
  ["🇮🇳", "Índia", "+91"],
  ["🇨🇳", "China", "+86"],
  ["🇮🇱", "Israel", "+972"],
  ["🇻🇪", "Venezuela", "+58"],
  ["🇺🇦", "Ucrânia", "+380"],
];
